import { render, staticRenderFns } from "./CustomBannerSwiper.vue?vue&type=template&id=2f46f325&scoped=true"
import script from "./CustomBannerSwiper.vue?vue&type=script&lang=js"
export * from "./CustomBannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./CustomBannerSwiper.vue?vue&type=style&index=0&id=2f46f325&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46f325",
  null
  
)

export default component.exports